// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"bfda698b","94":"7a8d49fb","239":"6f6dfc93","259":"2c4ecd7e","345":"46af8c02","451":"01c5bcba","512":"e8be59d4","525":"8d8d0cce","553":"ef709b10","640":"23b89c48","965":"07f749bd"}[chunkId] + ".chunk.js";
};